/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportRunMetricsResponseReportRunMetricResultStatus } from './ReportRunMetricsResponseReportRunMetricResultStatus';
import {
  ReportRunMetricsResponseReportRunMetricResultStatusFromJSON,
  ReportRunMetricsResponseReportRunMetricResultStatusFromJSONTyped,
  ReportRunMetricsResponseReportRunMetricResultStatusToJSON,
  ReportRunMetricsResponseReportRunMetricResultStatusToJSONTyped,
} from './ReportRunMetricsResponseReportRunMetricResultStatus';

/**
 *
 * @export
 * @interface ReportRunMetricsResponseReportRunMetricResult
 */
export interface ReportRunMetricsResponseReportRunMetricResult {
  /**
   * Output. The name of the metric.
   * @type {string}
   * @memberof ReportRunMetricsResponseReportRunMetricResult
   */
  metric_name?: string;
  /**
   * Output. The ID of the node which reports the metric.
   * @type {string}
   * @memberof ReportRunMetricsResponseReportRunMetricResult
   */
  metric_node_id?: string;
  /**
   *
   * @type {ReportRunMetricsResponseReportRunMetricResultStatus}
   * @memberof ReportRunMetricsResponseReportRunMetricResult
   */
  status?: ReportRunMetricsResponseReportRunMetricResultStatus;
  /**
   * Output. The detailed message of the error of the reporting.
   * @type {string}
   * @memberof ReportRunMetricsResponseReportRunMetricResult
   */
  message?: string;
}

/**
 * Check if a given object implements the ReportRunMetricsResponseReportRunMetricResult interface.
 */
export function instanceOfReportRunMetricsResponseReportRunMetricResult(
  value: object,
): value is ReportRunMetricsResponseReportRunMetricResult {
  return true;
}

export function ReportRunMetricsResponseReportRunMetricResultFromJSON(
  json: any,
): ReportRunMetricsResponseReportRunMetricResult {
  return ReportRunMetricsResponseReportRunMetricResultFromJSONTyped(json, false);
}

export function ReportRunMetricsResponseReportRunMetricResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReportRunMetricsResponseReportRunMetricResult {
  if (json == null) {
    return json;
  }
  return {
    metric_name: json['metric_name'] == null ? undefined : json['metric_name'],
    metric_node_id: json['metric_node_id'] == null ? undefined : json['metric_node_id'],
    status:
      json['status'] == null
        ? undefined
        : ReportRunMetricsResponseReportRunMetricResultStatusFromJSON(json['status']),
    message: json['message'] == null ? undefined : json['message'],
  };
}

export function ReportRunMetricsResponseReportRunMetricResultToJSON(
  json: any,
): ReportRunMetricsResponseReportRunMetricResult {
  return ReportRunMetricsResponseReportRunMetricResultToJSONTyped(json, false);
}

export function ReportRunMetricsResponseReportRunMetricResultToJSONTyped(
  value?: ReportRunMetricsResponseReportRunMetricResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metric_name: value['metric_name'],
    metric_node_id: value['metric_node_id'],
    status: ReportRunMetricsResponseReportRunMetricResultStatusToJSON(value['status']),
    message: value['message'],
  };
}
